/**
 * @author Iulian Ceapa <dev@sitemd.net>
 * @copyright © 2019-2026 SiteMD.
 */

SmoothScroll();

function checkScreenWidth() {
    const viewport = document.querySelector('meta[name="viewport"]');

    if (window.location.pathname === '/ro/about' ||
        window.location.pathname === '/ru/about' ||
        window.location.pathname === '/en/about'
    ) {
        viewport.setAttribute('content', 'width=' + (screen.width <= 1400 ? '1400' : 'device-width, height=device-height, initial-scale=1'));
        return;
    }

    viewport.setAttribute('content', 'width=' + (screen.width <= 340 ? '340' : 'device-width, height=device-height, initial-scale=1'));
}

window.addEventListener('DOMContentLoaded', checkScreenWidth);
window.addEventListener('resize', checkScreenWidth);

$(function () {
    let prev_scroll = window.scrollY;
    const header = $('header');
    const hide_threshold = 100;

    // Initial setup if the scroll position is not at 0
    if (prev_scroll > 0) {
        header.addClass('header-fixed');
    }

    $(window).scroll(function () {
        let current_scroll = window.scrollY;

        // Handling negative scroll values (Safari macOS)
        current_scroll = Math.max(0, current_scroll);
        prev_scroll = Math.max(0, prev_scroll);

        // Hiding or displaying the menu based on the scroll direction
        if (current_scroll > hide_threshold && current_scroll > prev_scroll) {
            header.addClass('hide');
        } else {
            header.removeClass('hide').addClass('header-fixed');
            if (current_scroll === 0) {
                header.removeClass('header-fixed');
            }
        }
        prev_scroll = current_scroll;
    });
});

const mask_phone = document.querySelectorAll('form input[name="phone"]');
if (mask_phone) {
    mask_phone.forEach(phone => {
        window.intlTelInput(phone, {
            autoPlaceholder: 'off',
            hiddenInput: phone.name,
            initialCountry: 'md',
            preferredCountries: ['md', 'ro'],
            separateDialCode: true,
            utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
        });
    });
}

document.querySelectorAll('.anchor').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
        let target = this.getAttribute('href');
        if (target) {
            gsap.to(window, {
                duration: 0,
                scrollTo: { y: target }
            });
        }
    });
});

// $('.section-1 .btn').on('click', function (e) {
//     dataLayer.push({ 'event': 'begin_form' });
// });

var form_start = false;
$('form .form-control').focus(function () {
    if (form_start == false) {
        dataLayer.push({ 'event': 'form_start' });
        form_start = true;
    }
});

$('form').submit(function (e) {
    e.preventDefault();

    const btn_submit = $(this).find('button[type="submit"]');
    btn_submit.attr('disabled', true);

    dataLayer.push({ 'event': 'form_submit' });

    const alert = (message, type) => {
        let wrapper = document.createElement('div')
        wrapper.innerHTML = [
            `<div class="alert alert-${type} alert-dismissible" role="alert">`,
            `   <div>${message}</div>`,
            '   <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>',
            '</div>'
        ].join('');

        $('.form-response').append(wrapper);
    }

    $.ajax({
        url: $(this).attr('action'),
        method: $(this).attr('method'),
        data: $(this).serialize() + '&submit=submit',
        dataType: 'json',
    }).done(function (response) {
        if (response == true) {
            alert('Mesajul a fost expediat cu succes!', 'success');
            dataLayer.push({ 'event': 'lead_generated' });
        } else {
            alert('Eroare în procesarea formularului. Vă rugăm să încercați din nou mai târziu.', 'warning');
        }
    }).fail(function (error) {
        alert('Eroare în timpul expedierii formularului. Vă rugăm să încercați din nou.', 'danger');
    }).always(function () {
        btn_submit.attr('disabled', false);
    });

    this.reset();
});

const section_video = document.querySelector('#section-video');
if (section_video) {
    const swiper_section_video = new Swiper('#section-video .swiper', {
        breakpoints: {
            0: {
                slidesPerView: 'auto',
                spaceBetween: 16
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 24
            },
            1200: {
                slidesPerView: 'auto'
            },
            1400: {
                slidesPerView: 4
            }
        },
        grabCursor: true,
        slidesPerView: 4,
        spaceBetween: 24,
        loop: false
    });

    document.querySelectorAll('video').forEach(video => {
        video.load(); // IMPORTANT

        video.addEventListener('loadeddata', () => {
            try {
                video.currentTime = 0.01;
            } catch (e) { }
        });
    });
}